module.exports = __webpack_public_path__ + "static/media/img109.31529f3a.jpg";